<template>
  <div class="login">
    <div class="contentz">
      <div class="imgBox">
        <img v-default-img src="./formBg.jpg" alt height="550px" width="300px" />
      </div>
      <div class="form">
        <div class="logo">
          消防水系统全生命周期监测
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="密码登录" name="0">
            <span slot="label">
              <i style="margin-right: 5px;vertical-align: -1px" class="iconfont iconmima"></i
              >密码登录
            </span>
            <el-form
              class="loginForm"
              :model="LoginForm"
              ref="LoginForm"
              :rules="rule"
              hide-required-asterisk
              :show-message="false"
            >
              <el-form-item prop="username">
                <b>账户：</b>
                <el-input
                  class="input"
                  type="text"
                  v-model.trim="LoginForm.userName"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="passwd">
                <b>密码：</b>
                <el-input
                  class="input"
                  type="password"
                  v-model="LoginForm.passwd"
                  show-passwd
                ></el-input>
              </el-form-item>
              <el-form-item v-if="!dragSuc">
                <div id="captcha" ref="captcha"></div>
              </el-form-item>
              <el-form-item class="dragSuc is-success" v-else>
                <el-input
                  type="text"
                  readonly
                  value="已成功验证"
                  prefix-icon="el-icon-success"
                ></el-input>
              </el-form-item>
              <el-checkbox class="remmber blueCheckbox" v-model="remmber">记住账号</el-checkbox>
              <div class="forget">
                <router-link to="/admin">忘记密码?</router-link>
              </div>
              <el-form-item>
                <el-button type="primary" class="submit" @click="submit" :loading="loading">
                  <span>用户登录</span>
                </el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="1">
            <span slot="label">
              <i style="margin-right: 5px;vertical-align: -1px" class="iconfont iconyanzhengma"></i
              >验证码登录
            </span>
            <el-form
              class="loginForm"
              :model="LoginForm1"
              ref="LoginForm1"
              :rules="rule"
              hide-required-asterisk
              :show-message="false"
            >
              <el-form-item prop="phone">
                <b>手机号：</b>
                <el-input
                  class="input"
                  type="text"
                  v-model.trim="LoginForm1.phone"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <b>验证码：</b>
                <el-input class="input" v-model="LoginForm1.phoneCode" show-passwd></el-input>
                <el-button type="primary" @click="getCode" :disabled="timeOut" id="phoneCode"
                  >获取验证码</el-button
                >
              </el-form-item>
              <el-checkbox class="remmber blueCheckbox" v-model="remmber">记住账号</el-checkbox>
              <div class="forget">
                <router-link to="/admin">忘记密码?</router-link>
              </div>
              <el-form-item>
                <el-button type="primary" class="submit" @click="submit" :loading="loading">
                  <span>用户登录</span>
                </el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="two_code">
      <div class="two_code_top">
        <p class="scan_line"></p>
        <img v-default-img height="100px" width="100px" :src="imgUrl" alt />
      </div>
      <div class="two_code_bottom">
        <p style="color: #5691fd">扫描二维码下载手机APP</p>
        <p style="color: #999b9e">体验更高效 服务更便捷</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { fnJigsaw } from './jigsaw.js'
  import { obj2urlsp } from 'utils'
  export default {
    data() {
      let validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入电话号码'))
        } else if (!/^([1]\d{10})$/.test(value)) {
          callback(new Error('请输入正确电话号码'))
        } else {
          callback()
        }
      }
      return {
        activeName: '0',
        timeOut: false,
        imgUrl: '',
        LoginForm: {
          userName: '',
          passwd: ''
        },
        LoginForm1: {
          phone: '',
          phoneCode: ''
        },
        loading: false,
        rule: {
          userName: [
            {
              required: true,
              message: '请输入用户名',
              trigger: 'change'
            }
          ],
          passwd: [
            {
              required: true,
              message: '请输入密码',
              trigger: 'change'
            }
          ],
          phone: [
            {
              validator: validatePhone,
              trigger: 'change'
            }
          ]
        },
        remmber: true,
        dragSuc: false,
        sendNew: [],
        sendNewName: [],
        sendNewTitle: []
      }
    },

    mounted() {
      this.imgUrl = process.env.API_HOST + 'operation/jpg/apkcode.jpg'
      const that = this
      fnJigsaw(this.$refs['captcha'], function() {
        that.dragSuc = true
      })
      that.remmber = localStorage.getItem('remmber') == 'true' ? true : false
      if (that.remmber && localStorage.getItem('userAccount')) {
        that.LoginForm.userName = localStorage.getItem('userAccount')
      }
    },
    created() {
      var t = this

      document.onkeydown = function(e) {
        if (window.event == undefined) {
          var key = e.keyCode
        } else {
          var key = window.event.keyCode
        }

        //enter的ASCII码是13

        if (key == 13) {
          t.submit() //t.登录方法
        }
      }
    },
    watch: {},
    methods: {
      // 获取验证码
      getCode() {
        this.$refs.LoginForm1.validateField('phone', error => {
          if (!error) {
            let seconds = 59
            let intervalName = setInterval(() => {
              this.timeOut = true
              let num = seconds--
              if (document.getElementById('phoneCode')) {
                document.getElementById('phoneCode').innerText = num + 's' + '再次发送'
              }
              if (!num) {
                clearInterval(intervalName)
                this.timeOut = false
                document.getElementById('phoneCode').innerText = '获取验证码'
                // return;
              }
              if (this.stopTime === -1) {
                clearInterval(intervalName)
                this.timeOut = false
              }
            }, 1000)

            let params = new URLSearchParams()
            params.append('phone', this.LoginForm1.phone)
            this.$axiospost('auth/token/sendCodeByPhone', params).then(res => {
              if (res.data.status === 10000) {
                this.$message.success('发送成功')
              } else {
                this.$message.error('发送失败')
              }
            })
          } else {
            this.$message.error('请输入正确的手机号')
          }
        })
      },
      submit() {
        if (this.activeName === '0') {
          if (!this.dragSuc) {
            this.$message.error('请进行识别验证')
            return
          }
          this.$refs.LoginForm.validate(valid => {
            if (valid) {
              this.sendNewName = []
              this.sendNewTitle = []
              this.loading = true
              this.$axiospost(
                'auth/token/login',
                obj2urlsp({
                  ...this.LoginForm,
                  type: 2
                })
              ).then(
                res => {
                  //console.log(res, "res");
                  if (res.data.status === 10000) {
                    //console.log(res.data.data.user);
                    this.$axiosget(
                      'manager/companySystem/findNewNameAndFlagByCompanyId/'.concat(
                        res.data.data.companyId
                      )
                    ).then(response => {
                      let sendNew = response.data.data || []
                      // let sendNew = (response.data.data || []).filter(it => it.title !== '-1' && it.title !== -1)
                      localStorage.setItem('sendNew', JSON.stringify(sendNew))
                      this.sendNew = sendNew
                    })
                    sessionStorage.setItem('startSocket', true)
                    this.$store.commit('SET_SOCKET', true)
                    this.$store.commit('SET_USER', res.data.data.user)
                    localStorage.setItem('companyId', res.data.data.companyId)
                    localStorage.setItem('user', JSON.stringify(res.data.data.user))
                    localStorage.setItem('username', res.data.data.user.username)
                    localStorage.setItem('remmber', this.remmber)
                    localStorage.setItem('token', res.data.data.token)
                    localStorage.setItem('securityLevel', res.data.data.securityLevel)
                    localStorage.setItem('userId', res.data.data.user.id)
                    localStorage.setItem('userAccount', this.LoginForm.userName)
                    localStorage.setItem('title', res.data.data.user.title)
                    localStorage.setItem('userphone', this.LoginForm.userName)
                    localStorage.setItem('companyType', res.data.data.type)

                    this.$store.dispatch('addRoutes').then(() => {
                      this.$router.push({
                        path: '/waterSystemHome'
                      })
                    })
                  }
                  this.loading = false
                },
                e => {
                  this.loading = false
                }
              )
            } else {
              this.$message.error('请输入用户名和密码')
            }
          })
        } else {
          this.$refs.LoginForm1.validate(valid => {
            if (valid) {
              let params = new URLSearchParams()
              params.append('phone', this.LoginForm1.phone)
              params.append('code', this.LoginForm1.phoneCode)
              params.append('type', 2)
              this.$axiospost('auth/token/loginPhone', params).then(res => {
                if (res.data.status === 10000) {
                  this.$store.commit('SET_SOCKET', true)
                  this.$store.commit('SET_USER', res.data.data.user)
                  localStorage.setItem('companyId', res.data.data.companyId)
                  localStorage.setItem('user', JSON.stringify(res.data.data.user))
                  localStorage.setItem('username', res.data.data.user.username)
                  localStorage.setItem('remmber', this.remmber)
                  localStorage.setItem('token', res.data.data.token)
                  localStorage.setItem('securityLevel', res.data.data.securityLevel)
                  localStorage.setItem('userId', res.data.data.user.id)
                  localStorage.setItem('userAccount', this.LoginForm1.phone)
                  localStorage.setItem('title', res.data.data.user.title)
                  this.$store.dispatch('addRoutes').then(() => {
                    this.$router.push({
                      path: '/waterSystem'
                    })
                  })
                }
              })
            } else {
              this.$message.error('请输入正确的手机号')
            }
          })
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  @keyframes scan {
    0% {
      top: 16px;
    }
    100% {
      top: 110px;
    }
  }
  /deep/ .el-tabs--border-card > .el-tabs__content {
    padding: 90px 90px 50px 90px;
    background: #181c2e;
  }
  /deep/ .el-tabs__item {
    color: #5a648e;
    width: 150px;
    text-align: center;
  }
  /deep/ .el-tabs__item.is-active {
    color: #fff;
    i {
      color: #1f83e5;
    }
  }
  /deep/ .el-tabs__nav-wrap::after {
    background-color: #232941;
  }
  /deep/ .el-tabs__header {
    margin-bottom: -45px;
  }
  /deep/.el-tabs__content {
    padding-top: 75px;
    padding-left: 10px;
    padding-right: 10px;
    margin: 0 -10px;
  }
  #phoneCode {
    position: absolute;
    right: 0;
  }
  .loginForm .el-form-item {
    width: 300px;
    height: 42px;
    margin-bottom: 25px;
    display: block;
    position: relative;
  }

  .loginForm .el-form-item b {
    position: absolute;
    left: 15px;
    top: 1px;
    color: #fff;
    font-size: 14px;
    z-index: 2;
    font-weight: normal;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .loginForm /deep/ .el-input__inner {
    height: 42px;
    line-height: 42px;
    font-size: 14px;
    text-indent: 40px;
    background: #2e3657;
    color: #fff;
    // border: 0 none;
  }

  .loginForm /deep/ .el-input__inner {
    padding-left: 30px;
  }

  .dragSuc /deep/ .el-icon-success {
    font-size: 26px;
    line-height: 42px;
    margin-left: 8px;
  }

  .login {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .login .contentz {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 550px;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  }

  .login .form {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 100%;
    padding: 0 78px;
    height: 550px;
    background: #181c2e;
  }

  .login .form .logo {
    width: 302px;
    height: 105px;
    line-height: 1;
    color: #fff;
    font-size: 24px;
    text-align: center;
    padding-top: 82px;
    margin-bottom: 36px;
    background-image: radial-gradient(
      54.2% 104% at center top,
      rgba(80, 199, 255, 0.5) 0%,
      rgba(80, 199, 255, 0.1) 32.4%,
      rgba(24, 28, 46, 0.6) 50%,
      rgba(24, 28, 46, 0.8) 100%
    );
    position: relative;
  }

  .login .form .headImg {
    margin-top: 22px;
  }

  .login .form h2 {
    margin: 0;
    font-size: 18px;
    margin-bottom: 18px;
    color: #5968a5;
    padding-left: 15px;
    display: inline-block;
    font-weight: normal;
  }

  .login .form .el-form {
    width: 300px;
  }

  .login .form .el-form .el-form-item:nth-of-type(3) {
    margin-bottom: 0;
  }

  .login .content .el-form-item:nth-of-type(3) /deep/ input {
    text-indent: 16px;
  }

  .login .form .el-form .remmber,
  .login .form .el-form .forget {
    margin: 23px 0;
  }

  .login .form .el-form .forget {
    float: right;
    text-align: center;
  }

  .login .form .el-form .forget a {
    color: #1f83e5;
    font-size: 14px;
    text-decoration: none;
  }

  .login .remmber /deep/.el-checkbox__label {
    font-size: 12px;
    color: #9096b0;
  }

  .login .form .submit {
    width: 302px;
    height: 48px;
    line-height: 48px;
    background: #306ac9;
    padding: 0;
    border-radius: 0;
    border: 0 none;
    position: relative;
  }

  .login .form .submit span {
    position: relative;
    z-index: 2;
    color: #fff;
    font-size: 16px;
    display: inline-block;
  }

  .login .form .submit:before {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 0;
    width: 0;
    height: 100%;
    content: '';
    display: block;
  }

  .login .form .submit:hover:before {
    width: 100%;
    left: 0;
    background: #224e95;
    -webkit-transition: all 0.25s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: all 0.25s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  .login .two_code {
    position: absolute;
    left: 55%;
    top: 50%;
    transform: translateX(434px) translateY(-50%);
    width: 164px;
    height: 192px;
  }

  .login .two_code .two_code_top {
    padding: 17px 31px;
    height: 135px;
    border-top: 1px solid #2a2d35;
    border-left: 1px solid #2a2d35;
    border-right: 1px solid #2a2d35;
    position: relative;
    .scan_line {
      position: absolute;
      width: 100px;
      height: 8px;
      background-image: radial-gradient(#00a3c6, transparent);
      animation: scan 3s ease-in-out infinite alternate;
    }
  }

  .login .two_code .two_code_bottom {
    padding-top: 8px;
    height: 53px;
    background-color: #2a2e37;
    border-bottom: 1px solid #3f434a;
    border-left: 1px solid #3f434a;
    border-right: 1px solid #3f434a;
  }

  .login .two_code .two_code_bottom p {
    font-size: 12px;
    line-height: 19px;
    text-align: center;
  }

  .blueCheckbox/deep/.el-checkbox__inner {
    background-color: rgba(86, 145, 253, 1);
    border: 1px solid rgba(86, 145, 253, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/password/waterSystemlogin/index.vue